module.exports = __webpack_public_path__ + "img/paesaggio 2.040fea1d.jpeg";